import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [

  {
    path: '',
    title: '-- Principal',
    moduleName: '',
    icon: '',
    class: 'header',
    groupTitle: true,
    submenu: []
  },
  {
    path: '/dashboard/usuario/list-usuario',
    title: 'Usuarios',
    moduleName: 'usuario',
    icon: 'user-check',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['administrador']
  },
  {
    path: '/dashboard/evaluacion-estudiante/list-evaluacion-estudiante',
    title: 'Evaluación de Estudiantes',
    moduleName: 'evaluacion-estudiante',
    icon: 'edit-3',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['estudiante']
  },
  {
    path: '/dashboard/evaluacion-estudiante/mis-evaluaciones-realizadas',
    title: 'Mis Evaluaciones Realizadas',
    moduleName: 'evaluacion-estudiante',
    icon: 'check-circle',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['estudiante']
  },
  {
    path: '/dashboard/estudiantes/list-estudiante',
    title: 'Estudiantes',
    moduleName: 'gestion-estudiantes',
    icon: 'users',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['administrador', 'docente']
  },
    {
    path: '/dashboard/cursos/list-curso',
    title: 'Cursos',
    moduleName: 'gestion-cursos',
    icon: 'book',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['administrador', 'docente']
  },
  {
    path: '/dashboard/lectura/list-lectura',
    title: 'materiales',
    moduleName: 'lectura',
    icon: 'book-open', 
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['administrador', 'docente']
  },
  {
    path: '/dashboard/evaluacion/list-evaluacion',
    title: 'Evaluación',
    moduleName: 'evaluacion',
    icon: 'file-text',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['administrador', 'docente'],
  },
  {
    path: '/dashboard/resultados/list-resultados',
    title: 'Resultados',
    moduleName: 'resultados',
    icon: 'bar-chart-2',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['administrador', 'docente'],
  },
  // {
  //   path: '',
  //   title: 'Reportes',
  //   moduleName: 'reportes',
  //   icon: 'bar-chart-2',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   roles: ['distribuidor', 'administrador'],
  //   submenu: [
  //     {
  //       path: '/dashboard/reportes/stock',
  //       title: 'Stock',
  //       moduleName: 'dashboard',
  //       icon: 'archive',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: [],
  //       roles: ['administrador', 'distribuidor']
  //     },
  //   ]
  // },
];
